<template>
    <v-app v-scroll="onScroll" :style="cssProps">
        <Navbar :color="toolbarColor" :smallLogo="smallLogo" :dark="dark" :dense="dark"/>
        <v-content>
            <router-view/>
        </v-content>
        <v-btn
                v-show="offsetTop > 100"
                color="primary"
                bottom
                floating
                fixed
                right
                dark
                fab
                @click.native="scrollToTop"
        >
            <v-icon>keyboard_arrow_up</v-icon>
        </v-btn>
        <v-footer dark height="auto">
            <v-card flat tile color="secondary" class="white--text text-xs-center">
                <v-card-text class="pa-2">
                    <v-btn
                            v-for="icon in icons"
                            :key="icon"
                            class="mx-3 white--text"
                            icon
                            :to="icon.link"
                    >
                        <v-icon size="24px">{{ icon.icon }}</v-icon>
                    </v-btn>
                </v-card-text>

                <v-card-text class="footer white--text pt-0">
                    Cubesoft Piotr Arent
                </v-card-text>
                <v-card-text class="footer white--text pt-0">
                    NIP: 5542827750, REGON: 382175717
                </v-card-text>
                <v-card-text class="footer white--text pt-0"
                >tel.: <a class="footer-text" href="tel:+48 535 222 830">+48 535 222 830</a>, e-mail:
                    <a class="footer-text" href="mailto:piotr.arent@cube-soft.eu">piotr.arent@cube-soft.eu</a>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-text class="white--text">
                    &copy;2019 — <strong>Cubesoft</strong>
                </v-card-text>
            </v-card>
        </v-footer>
    </v-app>
</template>

<script>
    import Navbar from "../src/components/Navbar";
    import * as router from "vue-router";

    export default {
        name: "App",
        components: {Navbar},
        data() {
            return {
                offsetTop: 0,
                toolbarColor: "background",
                dark: false,
                smallLogo: false,
                icons: [
                    {icon: "fab fa-linkedin", link: "linkedin"},
                    {icon: "fab fa-facebook", link: "facebook"},
                    {icon: "fab fa-facebook-messenger", link: "messenger"},
                    {icon: "fab fa-instagram", link: "instagram"},
                    {icon: "fab fa-twitter", link: "twitter"},
                    {icon: "fab fa-snapchat", link: "snapchat"},
                    {icon: "fab fa-github", link: "github"}
                ]
            };
        },
        methods: {
            scrollToTop() {
                this.$vuetify.goTo(0, {
                    duration: 300,
                    offset: 0,
                    easing: "easeOutCubic"
                });
                this.$router.push(`/${this.$i18n.locale}`);
            },
            onScroll() {
                this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
                // this.offsetTop > 100 ? this.toolbarColor="black" : this.toolbarColor="#00000000"
                if (this.offsetTop < 1) {
                    this.$router.push(`/${this.$i18n.locale}`);
                }else if (this.offsetTop > 100) {
                    this.toolbarColor = "primary";
                    this.dark = true;
                    this.smallLogo = true;
                } else {
                    this.toolbarColor = "background";
                    this.dark = false;
                    this.smallLogo = false;
                }
            }
        },
        computed: {
            cssProps() {
                return {
                    '--primary': this.$vuetify.theme.primary,
                    '--secondary': this.$vuetify.theme.secondary,
                    '--background': this.$vuetify.theme.background,
                    '--background2': this.$vuetify.theme.background2,
                    '--accent': this.$vuetify.theme.accent,
                    '--error': this.$vuetify.theme.error,
                    '--info': this.$vuetify.theme.info,
                    '--success': this.$vuetify.theme.success,
                    '--warning': this.$vuetify.theme.warning
                }
            }
        }
    }
</script>

<style lang="scss">
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        background-color: var(--primary);
    }

    #app > div > footer > div {
        width: 100%;
    }

    .footer-text {
        color: #e5e9ec !important;
        caret-color: #f4f4f4 !important;
    }
</style>
